// there is no need for now to display it on non sccom brands, but still there is a way to
// do it later if we will need it
import { useBonusesPictogram } from '../../../../AppSCCOM/components/BonusesPictogram/hooks';
import { useIsSC } from '../../../../hooks/useIsSC';
import type { CSSProperties } from 'react';
import { Counter } from '@modulor/react';

const BonusesNotification = () => {
  const isSCCOM = useIsSC();
  const hasNewBonuses = useBonusesPictogram();
  return isSCCOM && hasNewBonuses ? (
    <Counter
      value={0}
      style={
        {
          '--counter-background': 'var(--icon-notification)',
        } as CSSProperties
      }
    />
  ) : null;
};
export default BonusesNotification;
